
<div
  :class="['text-input', { disabled, 'has-slot': hasDefaultSlot, 'has-symbol': symbol }]"
  :style="removeMargin ? { '--text-input-margin-bottom': 0 } : null"
>
  <dropdown
    flex
    :align="align"
    :active="active"
    @close="active = false"
  >
    <div class="input-wrapper">
      <label v-if="label" :for="id">{{ label }}</label>

      <span v-if="symbol" class="symbol">
        {{ symbol }}
      </span>

      <input
        ref="input"
        v-model.trim="localValue"
        :id="id"
        :name="id"
        :type="type"
        :required="required"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxlength"
        :autocomplete="options ? 'off' : 'on'"
        @input="update"
        @focus="active = true"
      />

      <span v-if="loading" class="slot">
        <span class="spinner" />
      </span>

      <div v-else-if="hasDefaultSlot" class="slot">
        <slot />
      </div>
    </div>

    <template #menu>
      <dropdown-menu
        hide-no-results
        :options="filteredOptions"
        :activeValue="value"
        @select="handleSelect"
      />
    </template>
  </dropdown>
</div>
